// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  --background: transparent;
  color: var(--ion-color-primary);
}
@media (width < 390px) {
  ion-button {
    font-size: 9px;
  }
}

.icon-only {
  font-size: var(--icon-size, 22px) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/burger-btn/burger-btn.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,+BAAA;AACF;AACE;EAJF;IAKI,cAAA;EAEF;AACF;;AACA;EACE,4CAAA;AAEF","sourcesContent":["ion-button {\n  --background: transparent;\n  color: var(--ion-color-primary);\n\n  @media (width < 390px) {\n    font-size: 9px;\n  }\n}\n\n.icon-only {\n  font-size: var(--icon-size, 22px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
